import React, { Suspense } from 'react';
import { ResourceType } from '@cotera/api';
import type { ArtifactRendererProps } from './types';
import { registerArtifactRenderer } from './registry';
import { FolderContentsPageArtifactView } from '@cotera/client/app/v1/folder/folder-contents.page';
import { Text } from '@cotera/client/app/components/ui';
import { ChatArtifactAccessGate } from './chat-artifact-access-gate';

type FolderPayload = {
  folderId?: string;
  name?: string;
};

const FolderArtifactSkeleton: React.FC = () => (
  <div className="h-full w-full bg-background flex flex-col min-h-0 overflow-hidden">
    <div className="flex-1 min-h-0 overflow-y-auto p-5">
      <div className="max-w-5xl mx-auto space-y-3">
        <div className="h-8 w-full rounded bg-coco-accent animate-pulse" />
        <div className="h-8 w-full rounded bg-coco-accent animate-pulse" />
        <div className="h-8 w-4/5 rounded bg-coco-accent animate-pulse" />
      </div>
    </div>
  </div>
);

const FolderArtifactRenderer: React.FC<ArtifactRendererProps> = ({
  artifact,
}) => {
  const payload = artifact.payload as FolderPayload;
  const folderId = payload?.folderId ?? artifact.artifactId;

  if (folderId === undefined || folderId === '') {
    return (
      <div className="h-full w-full flex items-center justify-center bg-background p-4">
        <Text.P className="text-muted-foreground">Folder not found</Text.P>
      </div>
    );
  }

  return (
    <ChatArtifactAccessGate
      type={ResourceType.Folder}
      id={folderId}
      artifactType="folder"
      title={payload?.name}
      fallback={<FolderArtifactSkeleton />}
    >
      <Suspense fallback={<FolderArtifactSkeleton />}>
        <FolderContentsPageArtifactView folderId={folderId} />
      </Suspense>
    </ChatArtifactAccessGate>
  );
};

registerArtifactRenderer('folder', FolderArtifactRenderer);
